import { render, staticRenderFns } from "./CourseResourceCard1.vue?vue&type=template&id=6e598405&scoped=true"
import script from "./CourseResourceCard1.vue?vue&type=script&lang=js"
export * from "./CourseResourceCard1.vue?vue&type=script&lang=js"
import style0 from "./CourseResourceCard1.vue?vue&type=style&index=0&id=6e598405&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e598405",
  null
  
)

export default component.exports